"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hasOwn_1 = __importDefault(require("./hasOwn"));
/**
 * Returns value at path of given object or provided default value.
 * will return `undefined` if no default is given and path does not resolve
 *
 * @example
 * import pathOr from '@carvana/futilities/pathOr';
 * pathOr({ data: { price: { baselineMin: 5000 } } }, 'data.price.baselineMin', 0)
 * // () => 5000
 */
var pathTo = function (obj, path, defaultTo) {
    var result = obj;
    var pathArr = path.split('.');
    while (pathArr.length) {
        var nextStep = pathArr.shift();
        if (result && hasOwn_1.default(result, nextStep)) {
            result = result[nextStep];
        }
        else {
            return defaultTo;
        }
    }
    return result;
};
exports.default = pathTo;
//# sourceMappingURL=pathOr.js.map